export enum fields {
    EDUCATIONAL_PROGRAM_LIST = 'EDUCATIONAL_PROGRAM_LIST',
    EDUCATIONAL_PROGRAM_DIALOG = 'EDUCATIONAL_PROGRAM_DIALOG',
    IS_OPEN_DIALOG = 'IS_OPEN_DIALOG',
    DIALOG_DATA = 'DIALOG_DATA',
    SEARCH_QUERY = 'SEARCH_QUERY',
    CURRENT_PAGE = 'CURRENT_PAGE',
    ALL_COUNT = 'ALL_COUNT',
    SORTING = 'SORTING',
    SORTING_FIELD = 'SORTING_FIELD',
    SORTING_MODE = 'SORTING_MODE',
}

export enum fetchingTypes {
    GET_EDUCATIONAL_PROGRAM = 'GET_EDUCATIONAL_PROGRAM',
    DELETE_EDUCATIONAL_PROGRAM = 'DELETE_EDUCATIONAL_PROGRAM',
    UPDATE_EDUCATIONAL_PROGRAM = 'UPDATE_EDUCATIONAL_PROGRAM',
    CREATE_EDUCATIONAL_PROGRAM = 'CREATE_EDUCATIONAL_PROGRAM',
}

export enum DirectionFields {
    ID = 'id',
    TITLE = 'title',
    NUMBER = 'number',
    QUALIFICATION = 'qualification',
    EDUCATIONAL_PROFILE = 'educational_profile',
    FACULTY = 'faculty',
    EDUCATION_FORM = 'education_form',
}